<template>
  <section class="section--pb-md Class__con">
    <schedule-to-day />
    <schedule-calendar :key="calendarId" />
    <modal-schedule @change="changeCalendar" />
  </section>
</template>
<script>
import ScheduleToDay from '@/views/pages/home/components/ScheduleToDay'
import ScheduleCalendar from '@/views/pages/home/components/ScheduleCalendar'
import ModalSchedule from '@/views/components/modals/ModalSchedule'

export default {
  components: { ModalSchedule, ScheduleCalendar, ScheduleToDay },
  data() {
    return {
      calendarId: 0
    }
  },
  methods: {
    changeCalendar() {
      this.calendarId++
    }
  }
}
</script>
